import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ChartConflictData {
  patientId: number;
  localImage: string;        // base64 data URL of the local (pending) chart
  remoteImage: string;       // base64 data URL of the chart already on the server
  remoteLastModified: Date;  // last modified date from the server's 409 response
}

export type ChartConflictResult = 'keep-local' | 'keep-remote';

@Component({
  selector: 'app-chart-conflict-dialog',
  templateUrl: './chart-conflict-dialog.component.html',
  styleUrls: ['./chart-conflict-dialog.component.css']
})
export class ChartConflictDialogComponent {

  selected: ChartConflictResult = null;

  constructor(
    public dialogRef: MatDialogRef<ChartConflictDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChartConflictData
  ) {}

  selectLocal(): void {
    this.selected = 'keep-local';
  }

  selectRemote(): void {
    this.selected = 'keep-remote';
  }

  confirm(): void {
    this.dialogRef.close(this.selected);
  }
}
